import { Component, type ErrorInfo, type ReactNode } from "react";

interface ReportVisualBoundaryProps {
  children: ReactNode;
  fallback: ReactNode;
}

interface ReportVisualBoundaryState {
  failed: boolean;
}

export class ReportVisualBoundary extends Component<
  ReportVisualBoundaryProps,
  ReportVisualBoundaryState
> {
  public override state: ReportVisualBoundaryState = { failed: false };

  public static getDerivedStateFromError(): ReportVisualBoundaryState {
    return { failed: true };
  }

  public override componentDidCatch(_error: Error, _info: ErrorInfo): void {
    // Runtime visual degradation is intentionally local; the textual equivalent remains visible.
  }

  public override render(): ReactNode {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
